import request from "@/utils/request"

export default function agentGetDailyReport(params) {
    return request({
        url: `/fund/order/agentGetDailyReport`,
        params: params
    })
}
